import reducer from './reducer';

export {
  fetchSearchResults,
  updateSearch,
  clearSearch,
  clearSearchHistory,
  loadSearchHistory,
} from './actions';

export default reducer;
